import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-combo-meter',
  template: `
    <div class="combo" [class.active]="comboCount > 0" [class.intense]="intensity >= 2">
      <div class="combo-bar">
        <div class="combo-fill" [style.width.%]="fillPercent"></div>
      </div>
      <div class="combo-label" *ngIf="comboCount > 0">
        <span class="combo-icon">&#9889;</span>
        <span class="combo-count">x{{ multiplier | arabicNumber:currLang }}</span>
      </div>
      <div class="combo-streak" *ngIf="comboCount > 1">
        {{ comboCount | arabicNumber:currLang }} {{ currLang === 'ar' ? 'متتالية' : 'streak' }}
      </div>
    </div>
  `,
  styles: [`
    .combo {
      display: flex;
      align-items: center;
      gap: calc(10px * var(--game-scale, 1));
      padding: calc(8px * var(--game-scale, 1)) calc(16px * var(--game-scale, 1));
      border-radius: 12px;
      background: rgba(255,255,255,0.05);
      transition: all 0.3s ease;
      width: 100%;
      max-width: 600px;
    }
    .combo.active {
      background: rgba(255,193,7,0.1);
      border: 1px solid rgba(255,193,7,0.3);
    }
    .combo.intense {
      animation: comboGlow 0.5s ease-in-out infinite alternate;
      background: rgba(255,193,7,0.15);
    }
    .combo-bar {
      flex: 1;
      height: calc(10px * var(--game-scale, 1));
      background: rgba(255,255,255,0.1);
      border-radius: 4px;
      overflow: hidden;
    }
    .combo-fill {
      height: 100%;
      background: linear-gradient(90deg, #FFC107, #FF9800);
      border-radius: 4px;
      transition: width 0.3s ease;
    }
    .combo-label {
      display: flex;
      align-items: center;
      gap: calc(4px * var(--game-scale, 1));
      color: #FFC107;
      font-weight: 800;
      font-size: calc(20px * var(--game-scale, 1));
    }
    .combo-icon { font-size: calc(22px * var(--game-scale, 1)); }
    .combo-streak {
      color: rgba(255,255,255,0.5);
      font-size: calc(14px * var(--game-scale, 1));
      font-weight: 500;
      white-space: nowrap;
    }
    @keyframes comboGlow {
      0% { box-shadow: 0 0 8px rgba(255,193,7,0.2); }
      100% { box-shadow: 0 0 20px rgba(255,193,7,0.4); }
    }
  `]
})
export class ComboMeterComponent {
  @Input() comboCount = 0;
  @Input() multiplier = 1;
  @Input() intensity = 0;
  @Input() currLang: any = 'en';

  get fillPercent(): number {
    // Fill bar based on combo, max at 8
    return Math.min(100, (this.comboCount / 8) * 100);
  }
}
